<div *ngIf="hideContent" class="col-lg-6 container-fluid justify-content-center py-4 align-items-center"
  style="min-height: 60vh" dir="rtl">
  <p-progressSpinner ariaLabel="loading" />
</div>


<div [hidden]="hideContent">

  <div class="container">
    <div class="d-flex mt-2 justify-content-between">
      <h2 class="v4-color-white">{{"General information about the test" | translator}}</h2>
      <p-selectButton *ngIf="assessmentIds.length > 1" [options]="filterOptions" [(ngModel)]="selectedFilterOptions"
        optionLabel="name" (ngModelChange)="getResults()" optionValue="value" />
    </div>

    <div class="row justify-content-center">
      <ng-container *ngFor="let item of topStats">
        <div class="col-3 my-2" *ngIf="!hideCards.includes(item.key) && !!item.value.value"
          [ngClass]="{ 'col': hasSubCards.includes(item.key) === true }" [id]="item.key">
          <div class="card assess-card h-100 d-flex flex-column justify-content-center align-items-center px-2 py-4">
            <span class="{{item.value.icon}} " style="width: 4rem; height: 4rem"></span>
            <hr class="hr w-75 border-4" />
            <h5 class="text-center p-2">{{item.key | translator}}</h5>
            <h1>{{item.value.value}}</h1>
            <ng-container *ngIf="hasSubCards.includes(item.key) && false">
              <hr class="hr w-75 border-4" />
              <div class="d-flex justify-content-center">
                <div *ngFor="let subItem of getSubCards(item.key) let i = index"
                  [ngClass]="{ 'border-right': i === 1 }">
                  <h5 class="text-center p-2">{{subItem.key | translator}}</h5>
                  <h1 class="text-center p-2">{{subItem.value.value}}</h1>
                </div>.
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <hr class="hr w-100 border-4 v4-color-white" />

  <div class="container py-4">
    <div class="row">
      <div class="col-md-7 col-12">
        <div class="row row-cols-2">
          <div class="col-md-6 col-12 p-2" *ngFor="let criteria of criterias">
            <div class="card assess-card">
              <table class="table">
                <thead>
                  <tr *ngIf="criterias.length == 1;">
                    <th colspan="3">{{ 'Result Grades' | translator }}</th>
                  </tr>
                  <tr *ngIf="criterias.length != 1;">
                    <th colspan="3">{{ criteria._id }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of criteria.data">
                    <td><i class="{{ item.icon }}"></i></td>
                    <td>{{ item.title }}</td>
                    <td>{{ item.from }} - {{ item.to }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5 col-12 flex justify-content-center p-2">
        <p-chart type="pie" [data]="totalGradesData" [options]="options" height="400"></p-chart>

        <div class="tooltips-container w-100 d-flex gap-3 mt-2">
          <div class="tooltip-item p-2" *ngFor="let label of totalGradesData?.labels; let i = index">
            <table dir="rtl" style="background: white; color: black">
              <thead>
                <tr>
                  <th>
                    <span>{{label}}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr [style.background]="
                  totalGradesData?.datasets[0]?.backgroundColor?.[i] 
                    ? totalGradesData.datasets[0].backgroundColor[i] 
                    : totalGradesData.datasets[0].backgroundColor[i % totalGradesData.datasets[0].backgroundColor.length]"

                    style="border: 2px solid white ;color: white; text-align: center; width: 100%;">
                  <td style="padding: 5px 10px">
                    <span>{{totalGradesData?.datasets[0]?.data[i]}} مختبر</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </div>

  <hr class="hr w-100 border-4 v4-color-white" />

  <!-- <div class="container py-4">
    <h2 *ngIf="alldata && alldata['Total number of who attempted']" class="v4-color-white">
      {{
      "A comparison between the overall average number of correct answers and incorrect answers"
      | translator
      }}
      <span class="text-primary">
        لـــ {{ alldata["Total number of who attempted"]?.value }}
        {{ "Experiment" | translator }}
      </span>
    </h2>
    <div class="row">
      <div class="col-4 col-md-3 d-flex justify-content-center align-items-center rounded-2 point-left">
        <h3 style="color: white">
          {{ "Total correct answers for all tests" | translator }}
        </h3>
      </div>
      <div class="col-8 col-md-4 px-5 py-5 f-flow">
        <p-chart type="pie" [data]="totalQuestionsDataGraph" [options]="options2" height="400" width="300"></p-chart>
      </div>
      <div class="col-4 col-md-2 d-flex flex-column gap-2 p-1-m-0">
        <div class="d-flex h-50 m-1-p-0">
          <div class="d-flex align-items-center rounded-2 point-left">
            <h3 style="color: white">
              {{ "Average response rate to legislative questions" | translator }}
            </h3>
          </div>
        </div>
        <div class="d-flex h-50">
          <div class="d-flex align-items-center rounded-2 point-left">
            <h3 style="color: white">
              {{ "Average response rate to procedural questions" | translator }}
            </h3>
          </div>
        </div>
      </div>
  
      <div class="col-8 col-md-3 d-flex flex-column gap-2">
        <div class="f-flow h-50 p-4">
          <p-chart type="pie" [data]="totalQuestionsDataGraph" [options]="options2"></p-chart>
        </div>
        <div class="f-flow h-50 p-4">
          <p-chart type="pie" [data]="totalQuestionsDataGraph" [options]="options2"></p-chart>
        </div>
      </div>
    </div>
  </div> -->

  <div class="container py-4">
    <h2 *ngIf="alldata && alldata['Overall average for the assessment in percentage']" class="v4-color-white">
      {{
      "Overall average heading"
      | translator
      }}
    </h2>
    <div class="row justify-content-center">
      <div class="col-3 my-2">
        <div class="card assess-card h-100 d-flex flex-column justify-content-center align-items-center px-2 py-4">
          <span class="{{ getIcon('Overall average for the assessment in percentage') }} "
            style="width: 4rem; height: 4rem"></span>
          <h5 class="text-center p-2">{{ 'Total Grades out of 100' | translator }}</h5>
          <hr class="hr w-75 border-4" />
          <h5 class="text-center p-2">{{'Overall average for the assessment in percentage' | translator}}</h5>
          <h1>
            {{
            alldata?.['Overall average for the assessment in percentage']
            ? formatScore(alldata['Overall average for the assessment in percentage'].value)
            : 'N/A'
            }}%
          </h1>
        </div>
      </div>

      <div class="col-3 my-2">
        <div class="card assess-card h-100 d-flex flex-column justify-content-center align-items-center px-2 py-4">
          <span class="{{ getIcon('Overall average for the assessment in marks') }} "
            style="width: 4rem; height: 4rem"></span>
          <h5>{{ ('Total Marks out of' | translator) + ' ' + (formatScore(alldata?.['Total Marks'].value)) }}</h5>
          <hr class="hr w-75 border-4" />
          <h5 class="text-center p-2">{{'Overall average for the assessment in marks' | translator}}</h5>
          <h1>
            {{
            alldata?.['Overall average for the assessment in marks']
            ? formatScore(alldata['Overall average for the assessment in marks'].value)
            : 'N/A'
            }}
          </h1>

        </div>
      </div>

      <div class="col-3 my-2">
        <div class="card assess-card h-100 d-flex flex-column justify-content-center align-items-center px-2 py-4">
          <span class="{{ getIcon('Overall average for the assessment in grades') }} "
            style="width: 4rem; height: 4rem"></span>
          <hr class="hr w-75 border-4" />
          <h5 class="text-center p-2">{{'Overall average for the assessment in grades' | translator}}</h5>
          <h1>
            {{
            alldata?.['Overall average for the assessment in grades']
            ? alldata['Overall average for the assessment in grades'].value
            : 'N/A'
            }}
          </h1>

        </div>
      </div>


    </div>

  </div>



  <hr class="hr w-100 border-4 v4-color-white " />

  <div class="container py-4" *ngIf="alldata?.domainAnswers?.length > 0">

    <h2 class="v4-color-white">
      {{
      "Correct answers according to topics"
      | translator
      }}
    </h2>

    <div class="row justify-content-center">

      <div *ngFor="let graph of alldata.domainAnswers; let j = index" class="col-4 col-md-3 g-2">

        <div class="card assess-card w-100 h-100 d-flex flex-column p-4 text-center">
          <div class="pb-3" *ngIf="graph._id">
            <h5 pTooltip="{{ graph._id | translator }}" style="color: white; min-height: 50px; max-height: 50px; overflow: hidden;">
              
              <span *ngIf="graph._id.parentId">{{graph._id.parentId}} > </span>
              {{ graph._id.label ? graph._id.label : graph._id  | translator }}

            </h5>
          </div>


          <div>
            <p-chart type="pie" [data]="{
              'labels': graph.labels,
              'datasets': graph.datasets
            }" [options]="options2" height="300" width="250"></p-chart>
          </div>
        </div>

      </div>
    </div>


  </div>

  <hr class="hr w-100 border-4 v4-color-white " />
  <div *ngIf="worstPerformingQuestions?.length > 0" class="container py-4">

    <div class="row pt-2">
      <div *ngFor="let question of worstPerformingQuestions; let j = index" class="col">
        <div
          class="card assess-card w-100 h-100 d-flex flex-column align-items-center justify-content-start p-4 text-center">
          <span class="icon-svg icon-svg-128" style="width: 4rem; height: 4rem"></span>
          <h1 class="v4-color-white">

            <!-- <span *ngIf="j == 0">*</span> --> {{ question.count - question.correct }}

          </h1>
          <b class="text-primary">{{ "from" | translator }} {{ question.count }}
            {{ "Assessment Attendees" | translator }}</b>
          <hr class="hr w-75 border-4 v4-color-white" />

          <p class="text-start">
            {{ "They got the question wrong" | translator}}
            <b>({{ cleanQuestionText(question.data.questionText) }})</b>
            {{"That is of all" |translator }} <b>{{ calculatePercentage(question)}}%</b> {{"of all the test takers" |
            translator}}
          </p>


        </div>
      </div>
    </div>

    <div class="row pt-1">
      <div *ngFor="let question of worstPerformingQuestions; let j = index" class="col">
        <div
          class="card assess-card w-100 h-100 d-flex flex-column align-items-center justify-content-start p-4 text-center">

          <!-- <div *ngFor="let option of question.data.meta.fields; let i = index">
            <p class="text-start" *ngIf="question.data.meta.correct === option.label">
              <b>{{ "the correct answer" | translator}}:</b> <span> {{ option.label }}</span>
            </p>
          </div> -->

          <div>
            <p class="text-start">
              <b>{{ "the correct answer" | translator}}:</b> <span> {{ question.data.meta.correct }}</span>
            </p>
          </div>

        </div>
      </div>
    </div>

    <div class="row pt-1" *ngIf="worstPerformingQuestions[0].data.meta.selectedTopic">
      <div *ngFor="let question of worstPerformingQuestions; let j = index" class="col">
        <div
          class="card assess-card w-100 h-100 d-flex flex-column align-items-center justify-content-start p-4 text-center">

          <h5>{{ question?.data?.meta?.selectedTopic?.label }}</h5>
        </div>
      </div>
    </div>
  </div>

  <hr class="hr w-100 border-4 v4-color-white" />
  <div class="d-flex gap-2">
    <button *ngIf="!downloadCWExcel && assessmentIds.length > 1" style="background-color: #217346;" class="my-3 py-2 v4-btn-every"
      (click)="exportCorrectWrongExcel()" >
      {{ 'correct incorrect stats' | translator }} <i class="fa-regular fa-file-excel"></i>
    </button>
    <p-progressSpinner class="v4-spin" *ngIf="downloadCWExcel" ariaLabel="loading"></p-progressSpinner>

    <button *ngIf="!downloadExcel && assessmentIds.length > 1" style="background-color: #217346;" class="my-3 py-2 v4-btn-every"
      (click)="exportExcel()" >
      {{ 'Download Excel' | translator }} <i class="fa-regular fa-file-excel"></i>
    </button>
    <p-progressSpinner class="v4-spin" *ngIf="downloadCWExcel" ariaLabel="loading"></p-progressSpinner>

    <button *ngIf="!downloadPdf && assessmentIds.length > 1" style="background-color: grey;" class="my-3 py-2 v4-btn-every"
      (click)="exportPdf()" >
      {{ 'Download PDF' | translator }} <i class="fa-regular fa-file-pdf"></i>
    </button>
    <p-progressSpinner class="v4-spin" *ngIf="downloadCWExcel" ariaLabel="loading"></p-progressSpinner>

    <button *ngIf="!downloadPowerPoint && assessmentIds.length > 1" style="background-color: #217346;" class="my-3 py-2 v4-btn-every"
      (click)="exportToPPT()" >
      {{ 'Download Powerpoint' | translator }} <i class="fa-regular fa-file-powerpoint"></i>
    </button>
    <p-progressSpinner class="v4-spin" *ngIf="downloadPowerPoint" ariaLabel="loading"></p-progressSpinner>
  
  </div>

  
  <div *ngIf="alldata && alldata?.listOfMuliTakers.length > 0" class=" py-4">

    <h2 class="v4-color-white">
      {{ "the list of users who have attempted multiple times" | translator}}
    </h2>
    <table class="custom-table pt-1">
      <thead>
        <tr>
          <th>{{"Email" | translator}}</th>
          <th>{{"Name" | translator}}</th>
          <th>{{"number of times" | translator}}</th>
          <th>{{"Assessments" | translator}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let rowData of alldata?.listOfMuliTakers">
          <td>{{ rowData._id }}</td>
          <td>{{ rowData.name }}</td>
          <td>{{ rowData.sum }}</td>
          <td>
            <ul>
              <li *ngFor="let assessment of rowData.assessments">{{ assessment }}</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <hr class="hr w-100 border-4 v4-color-white" />
</div>